import './Typography.css';
export default {
    "root": "Typography_root__lp5bn",
    "display-lg": "Typography_display-lg__lp5bn",
    "display-md": "Typography_display-md__lp5bn",
    "heading-xl": "Typography_heading-xl__lp5bn",
    "heading-lg": "Typography_heading-lg__lp5bn",
    "heading-md": "Typography_heading-md__lp5bn",
    "heading-sm": "Typography_heading-sm__lp5bn",
    "body-lg": "Typography_body-lg__lp5bn",
    "body-lg-bold": "Typography_body-lg-bold__lp5bn",
    "body-md": "Typography_body-md__lp5bn",
    "body-md-bold": "Typography_body-md-bold__lp5bn",
    "body-sm": "Typography_body-sm__lp5bn",
    "body-sm-bold": "Typography_body-sm-bold__lp5bn",
    "align-match-parent": "Typography_align-match-parent__lp5bn",
    "align-left": "Typography_align-left__lp5bn",
    "align-center": "Typography_align-center__lp5bn",
    "align-right": "Typography_align-right__lp5bn",
    "align-justify": "Typography_align-justify__lp5bn",
    "align-start": "Typography_align-start__lp5bn",
    "align-end": "Typography_align-end__lp5bn"
};
